import { gql, graphql } from "react-apollo"
import type { User } from "../types"

const MUTATE_UPDATE_USER = gql`
  mutation UpdateUser($id: ID!, $user: UserInput!) {
    updateUser(id: $id, user: $user) {
      id
      name
      email
      admin
    }
  }
`

const mutateUpdateUser = graphql(MUTATE_UPDATE_USER, {
  name: "mutateUpdateUser",
  props: ({ mutateUpdateUser }) => ({
    updateUser: (id: string, { name, email, admin, password }: User) =>
      mutateUpdateUser({
        variables: { id, user: { name, email, admin, password } }
      })
  })
})

export default mutateUpdateUser



// WEBPACK FOOTER //
// ./src/Users/queries/mutateUpdateUser.js